<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18 2C18.2652 2 18.5196 2.10536 18.7071 2.29289L21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V12C22 12.2652 21.8946 12.5196 21.7071 12.7071L18.7071 15.7071C18.5196 15.8946 18.2652 16 18 16H13.4142L7.70711 21.7071C7.51957 21.8946 7.26522 22 7 22H3C2.44772 22 2 21.5523 2 21V17C2 16.7348 2.10536 16.4804 2.29289 16.2929L8 10.5858V6C8 5.73478 8.10536 5.48043 8.29289 5.29289L11.2929 2.29289C11.4804 2.10536 11.7348 2 12 2H18ZM17.5858 4H12.4142L10 6.41421V11C10 11.2652 9.89464 11.5196 9.70711 11.7071L4 17.4142V20H6.58579L12.2929 14.2929C12.4804 14.1054 12.7348 14 13 14H17.5858L20 11.5858V6.41421L17.5858 4ZM16 6C17.1046 6 18 6.89543 18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6Z"
    fill="currentColor"
  />
</svg>
